<div class="review-dialog">
    <div class="dialog-header one-row">
        <h2>{{ data.mode === 'edit' ? 'Gemeinkosten bearbeiten' : 'Rechnung abgleichen' }}</h2>
        <span class="spacer"></span>
        <button mat-icon-button type="button" (click)="prevPage()" [disabled]="page <= 1" matTooltip="Vorherige Seite">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <span class="page-label">{{ page }} / {{ totalPages || '…' }}</span>
        <button
            mat-icon-button
            type="button"
            (click)="nextPage()"
            [disabled]="!totalPages || page >= totalPages"
            matTooltip="Nächste Seite"
        >
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="close()" matTooltip="Schließen">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="review-body">
        <div class="pdf-pane" #pdfPane>
            <div class="pdf-loading" *ngIf="pdfLoading && data?.pdfFile">PDF wird geladen …</div>
            <pdf-viewer
                *ngIf="pdfSrc"
                [src]="pdfSrc"
                [page]="page"
                [show-all]="false"
                [render-text]="true"
                [original-size]="false"
                [fit-to-page]="false"
                [autoresize]="true"
                [zoom-scale]="'page-width'"
                (after-load-complete)="onPdfLoad($event)"
                (page-rendered)="onPdfPageRendered()"
                (error)="onPdfError($event)"
            ></pdf-viewer>
            <div class="pdf-missing" *ngIf="!pdfSrc && !pdfLoading">
                <mat-icon>picture_as_pdf</mat-icon>
                <p>{{ data.mode === 'edit' ? 'Kein PDF hinterlegt.' : 'PDF fehlt – Review trotzdem möglich.' }}</p>
            </div>
            <div class="pdf-toolbar" *ngIf="pdfSrc || data?.pdfFile">
                <button
                    mat-stroked-button
                    type="button"
                    (click)="reloadPdf()"
                    [disabled]="!data?.pdfFile || pdfLoading"
                    matTooltip="PDF-Viewer neu laden"
                >
                    <mat-icon>refresh</mat-icon>
                    PDF neu laden
                </button>
                <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    (click)="openPdfInNewTab()"
                    matTooltip="PDF in neuem Tab öffnen"
                >
                    <mat-icon>open_in_new</mat-icon>
                    PDF öffnen
                </button>
            </div>
        </div>

        <div class="form-pane" #formPane>
            <p class="meta" *ngIf="data?.draft?.extract?.source">
                Quelle: {{ data.draft.extract.source }}
                <span *ngIf="data.draft.extract.overallConfidence != null">
                    · Confidence {{ (data.draft.extract.overallConfidence * 100) | number: '1.0-0' }}%
                </span>
            </p>
            <p class="meta extract-totals" *ngIf="extractNetto != null || extractBrutto != null">
                Extrakt-Gesamt:
                <span *ngIf="extractNetto != null">Netto {{ extractNetto | number: '1.2-2' }} €</span>
                <span *ngIf="extractNetto != null && extractBrutto != null"> · </span>
                <span *ngIf="extractBrutto != null">Brutto {{ extractBrutto | number: '1.2-2' }} €</span>
            </p>

            <div class="warnings" *ngIf="warnings?.length">
                <div *ngFor="let w of warnings">{{ w }}</div>
            </div>

            <mat-radio-group
                [formControl]="gemeinkostenTypCtrl"
                (change)="onTypChanged()"
                class="typ-group"
            >
                <mat-radio-button [value]="0">Allgemein</mat-radio-button>
                <mat-radio-button [value]="1">Labor</mat-radio-button>
                <mat-radio-button [value]="2">Tierarzt</mat-radio-button>
            </mat-radio-group>

            <div *ngIf="gemeinkostenTypCtrl.value === 2">
                <kiene-autocomplete
                    (elementSelected)="setTierarzt($event)"
                    [apiUrl]="'tierarzt/'"
                    [displayFields]="['titel', 'vorname', 'nachname']"
                    [kieneObject]="tierarzt"
                    [placeholder]="'Tierarzt'"
                >
                </kiene-autocomplete>
            </div>

            <div class="artikel-with-search">
                <kiene-autocomplete
                    (elementSelected)="setLieferant($event)"
                    [apiUrl]="'lieferant/'"
                    [displayField]="'bezeichnung'"
                    [kieneObject]="supplier"
                    [params]="lieferantParams"
                    [placeholder]="'Lieferant'"
                >
                </kiene-autocomplete>
                <button
                    mat-icon-button
                    type="button"
                    class="artikel-search-btn"
                    (click)="openLieferantPicker()"
                    [matTooltip]="nurHonorar ? 'Lieferant suchen' : 'Nebenkosten-Lieferant suchen / anlegen'"
                >
                    <mat-icon>search</mat-icon>
                </button>
            </div>

            <mat-form-field style="width: 100%">
                <mat-label>Kommentar (Kopf)</mat-label>
                <input [formControl]="kommentarCtrl" matInput />
            </mat-form-field>

            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Rechnungsnummer</mat-label>
                    <input [formControl]="rechnungNummerCtrl" matInput required />
                </mat-form-field>
                <mat-form-field style="width: 48%">
                    <mat-label>Rechnungsdatum</mat-label>
                    <input [formControl]="datumCtrl" [matDatepicker]="picker" matInput required />
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Leistungsdatum von</mat-label>
                    <input [formControl]="leistungsdatumVonCtrl" [matDatepicker]="lstgvon" matInput required />
                    <mat-datepicker-toggle [for]="lstgvon" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #lstgvon></mat-datepicker>
                </mat-form-field>
                <mat-form-field style="width: 48%">
                    <mat-label>Leistungsdatum bis</mat-label>
                    <input [formControl]="leistungsdatumBisCtrl" [matDatepicker]="lstgbis" matInput />
                    <mat-datepicker-toggle [for]="lstgbis" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #lstgbis></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="one-row review-flags">
                <mat-checkbox
                    *ngIf="!nurHonorar"
                    [(ngModel)]="fahrzeugManuell"
                    (ngModelChange)="onFahrzeugManuellChanged()"
                >
                    Fahrzeugbezogen (manuell)
                </mat-checkbox>
                <mat-checkbox [(ngModel)]="nurGesamtbetrag" (ngModelChange)="onNurGesamtbetragChanged()">
                    Nur Gesamtbetrag speichern
                </mat-checkbox>
            </div>

            <ng-container *ngIf="!nurGesamtbetrag">
                <div class="one-row">
                    <h3>Positionen ({{ positionen.length }})</h3>
                    <span class="spacer"></span>
                    <ng-container *ngIf="needsPosPagination">
                        <button
                            mat-icon-button
                            type="button"
                            (click)="prevPosPage()"
                            [disabled]="posPage <= 0"
                            matTooltip="Vorherige Positionen"
                        >
                            <mat-icon>navigate_before</mat-icon>
                        </button>
                        <span class="pos-page-label"
                            >{{ posPage + 1 }} / {{ posPageCount }}
                            <span class="pos-page-range"
                                >({{ posPageStart + 1 }}–{{
                                    posPageStart + pagedPositionRows.length
                                }})</span
                            ></span
                        >
                        <button
                            mat-icon-button
                            type="button"
                            (click)="nextPosPage()"
                            [disabled]="posPage >= posPageCount - 1"
                            matTooltip="Nächste Positionen"
                        >
                            <mat-icon>navigate_next</mat-icon>
                        </button>
                    </ng-container>
                </div>
                <p class="hint">
                    Je Zeile Artikel/Freitext und Konto. Fahrzeug/Kostenart bei Kfz oder wenn „Fahrzeugbezogen“ aktiv.
                    <ng-container *ngIf="needsPosPagination"
                        >· {{ posPageSize }} Positionen je Seite.</ng-container
                    >
                </p>

                <div
                    cdkDropList
                    [cdkDropListData]="pagedPositionRows"
                    (cdkDropListDropped)="positionDropped($event)"
                    class="position-list"
                >
                    <div
                        *ngFor="let row of pagedPositionRows; trackBy: trackPagedRow"
                        class="position-block"
                        cdkDrag
                    >
                    <div class="position-card">
                        <div class="one-row">
                            <button
                                type="button"
                                mat-icon-button
                                cdkDragHandle
                                matTooltip="Ziehen zum Sortieren"
                                class="drag-handle"
                            >
                                <mat-icon>drag_indicator</mat-icon>
                            </button>
                            <strong>Pos. {{ row.i + 1 }}</strong>
                            <button
                                type="button"
                                mat-icon-button
                                (click)="positionVerschieben(row.i, -1)"
                                [disabled]="row.i === 0"
                                matTooltip="Nach oben"
                            >
                                <mat-icon>keyboard_arrow_up</mat-icon>
                            </button>
                            <button
                                type="button"
                                mat-icon-button
                                (click)="positionVerschieben(row.i, 1)"
                                [disabled]="row.i >= positionen.length - 1"
                                matTooltip="Nach unten"
                            >
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            </button>
                            <span class="spacer"></span>
                            <button
                                (click)="positionEntfernen(row.i)"
                                mat-icon-button
                                type="button"
                                matTooltip="Entfernen"
                                [disabled]="positionen.length < 2"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>

                        <div class="one-row pos-artikel">
                            <div class="field-artikel artikel-with-search">
                                <kiene-autocomplete
                                    (elementSelected)="setPositionArtikel(row.i, $event)"
                                    [apiUrl]="'artikel_autocomplete/'"
                                    [displayField]="'artikel_me'"
                                    [focus]="false"
                                    [kieneObject]="positionArtikel[row.i]"
                                    [params]="artikelParams"
                                    [placeholder]="'Artikel'"
                                    [required]="false"
                                >
                                </kiene-autocomplete>
                                <button
                                    mat-icon-button
                                    type="button"
                                    class="artikel-search-btn"
                                    (click)="openPositionArtikelPicker(row.i)"
                                    [matTooltip]="nurHonorar ? 'Honorar-Artikel suchen / anlegen' : 'Nebenkosten-Artikel suchen / anlegen'"
                                >
                                    <mat-icon>search</mat-icon>
                                </button>
                            </div>
                            <mat-form-field class="field-text">
                                <mat-label>Freitext</mat-label>
                                <input [(ngModel)]="row.pos.bezeichnung" matInput placeholder="optional" />
                            </mat-form-field>
                        </div>
                        <div class="one-row">
                            <mat-form-field class="field-num">
                                <mat-label>Netto</mat-label>
                                <input [(ngModel)]="row.pos.kosten_netto" matInput kieneDeNumber inputmode="decimal" />
                                <span matSuffix>&euro;</span>
                            </mat-form-field>
                            <button
                                mat-stroked-button
                                type="button"
                                class="buchungsseite-btn"
                                [class.buchungsseite-h]="row.pos.buchungsseite === 'H'"
                                (click)="toggleBuchungsseite(row.i)"
                                [matTooltip]="
                                    row.pos.buchungsseite === 'H'
                                        ? 'Haben (Erstattung) – Klick → Soll'
                                        : 'Soll (Rechnung) – Klick → Haben'
                                "
                            >
                                {{ row.pos.buchungsseite === 'H' ? 'H' : 'S' }}
                            </button>
                            <mat-form-field class="field-num">
                                <mat-label>MwSt</mat-label>
                                <mat-select [(ngModel)]="row.pos.mwstsatz">
                                    <mat-option *ngFor="let s of mwstSaetze" [value]="s.value">{{ s.label }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button
                                mat-icon-button
                                type="button"
                                class="mwst-calc-btn"
                                (click)="mwstVomBetragAbziehen(row.i)"
                                [disabled]="!canMwstVomBetragAbziehen(row.i)"
                                matTooltip="MwSt abziehen (Brutto → Netto)"
                            >
                                <mat-icon>calculate</mat-icon>
                            </button>
                            <mat-form-field class="field-konto">
                                <mat-label>Konto</mat-label>
                                <input [value]="row.pos.konto_nr || ''" matInput readonly />
                            </mat-form-field>
                        </div>

                        <div class="one-row pos-fibu" *ngIf="!nurHonorar && showFahrzeugFibu(row.i)">
                            <div class="field-auto">
                                <kiene-autocomplete
                                    (elementSelected)="setPositionFahrzeug(row.i, $event)"
                                    [apiUrl]="'fibu_fahrzeug/'"
                                    [displayField]="'anzeige'"
                                    [focus]="false"
                                    [kieneObject]="positionFahrzeuge[row.i]"
                                    [params]="fahrzeugParams"
                                    [placeholder]="'Fahrzeug'"
                                    [required]="false"
                                >
                                </kiene-autocomplete>
                            </div>
                            <mat-form-field class="field-select">
                                <mat-label>Kostenart</mat-label>
                                <mat-select
                                    [(ngModel)]="row.pos.sachkonto"
                                    (selectionChange)="onKostenartChanged(row.i)"
                                >
                                    <mat-option [value]="null">–</mat-option>
                                    <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{
                                        k.label
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="one-row pos-fibu" *ngIf="nurHonorar">
                            <div class="field-auto">
                                <kiene-autocomplete
                                    (elementSelected)="setPositionHonorarTa(row.i, $event)"
                                    [apiUrl]="'fibu_honorar_ta/'"
                                    [displayField]="'anzeige'"
                                    [focus]="false"
                                    [kieneObject]="positionHonorarTas[row.i]"
                                    [params]="honorarTaParams"
                                    [placeholder]="'Honorar-TA'"
                                    [required]="false"
                                >
                                </kiene-autocomplete>
                            </div>
                            <mat-form-field class="field-select">
                                <mat-label>Kostenart</mat-label>
                                <mat-select
                                    [(ngModel)]="row.pos.sachkonto"
                                    (selectionChange)="onKostenartChanged(row.i)"
                                >
                                    <mat-option [value]="null">–</mat-option>
                                    <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{
                                        k.label
                                    }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="one-row pos-fibu" *ngIf="showZeilenTierarzt(row.i)">
                            <div class="field-auto">
                                <kiene-autocomplete
                                    (elementSelected)="setPositionTierarzt(row.i, $event)"
                                    [apiUrl]="'tierarzt/'"
                                    [displayFields]="['titel', 'vorname', 'nachname']"
                                    [focus]="false"
                                    [kieneObject]="positionTieraerzte[row.i]"
                                    [placeholder]="'Tierarzt (Zeile)'"
                                    [required]="false"
                                >
                                </kiene-autocomplete>
                            </div>
                        </div>
                    </div>
                    <div class="group-sum-hint" *ngIf="vehicleGroupSumHint(row.i) as hint">
                        {{ hint }}
                    </div>
                    </div>
                </div>

                <div class="one-row pos-pager-bottom" *ngIf="needsPosPagination">
                    <button mat-stroked-button type="button" (click)="prevPosPage()" [disabled]="posPage <= 0">
                        <mat-icon>navigate_before</mat-icon>
                        Zurück
                    </button>
                    <span class="pos-page-label">Seite {{ posPage + 1 }} / {{ posPageCount }}</span>
                    <button
                        mat-stroked-button
                        type="button"
                        (click)="nextPosPage()"
                        [disabled]="posPage >= posPageCount - 1"
                    >
                        Weiter
                        <mat-icon>navigate_next</mat-icon>
                    </button>
                </div>

                <div class="one-row pos-add-bottom">
                    <span class="spacer"></span>
                    <button
                        (click)="positionHinzufuegen()"
                        color="accent"
                        mat-stroked-button
                        type="button"
                    >
                        <mat-icon>add</mat-icon>
                        Position hinzufügen
                    </button>
                </div>
            </ng-container>

            <ng-container *ngIf="nurGesamtbetrag">
                <h3>Gesamtbetrag</h3>
                <p class="hint">
                    Positionen ausgeblendet – speichert eine Zeile. Freitext = Leistungsinhalt (was war es?), Beträge
                    unten.
                </p>
                <div class="artikel-with-search gesamt-artikel">
                    <kiene-autocomplete
                        (elementSelected)="setGesamtArtikel($event)"
                        [apiUrl]="'artikel_autocomplete/'"
                        [displayField]="'artikel_me'"
                        [focus]="false"
                        [kieneObject]="gesamtArtikel"
                        [params]="artikelParams"
                        [placeholder]="'Artikel'"
                        [required]="false"
                    >
                    </kiene-autocomplete>
                    <button
                        mat-icon-button
                        type="button"
                        class="artikel-search-btn"
                        (click)="openGesamtArtikelPicker()"
                        [matTooltip]="nurHonorar ? 'Honorar-Artikel suchen / anlegen' : 'Nebenkosten-Artikel suchen / anlegen'"
                    >
                        <mat-icon>search</mat-icon>
                    </button>
                </div>
                <mat-form-field style="width: 100%">
                    <mat-label>Leistungsinhalt (Freitext)</mat-label>
                    <input [(ngModel)]="gesamtBezeichnung" matInput placeholder="z.B. Diesel, Laboranalyse, Miete …" />
                </mat-form-field>
                <mat-form-field class="field-konto" style="width: 100%">
                    <mat-label>Konto</mat-label>
                    <input [value]="gesamtKontoNr || ''" matInput readonly />
                </mat-form-field>
                <div class="one-row pos-fibu" *ngIf="!nurHonorar && (fahrzeugManuell || gesamtFahrzeug)">
                    <div class="field-auto">
                        <kiene-autocomplete
                            (elementSelected)="setGesamtFahrzeug($event)"
                            [apiUrl]="'fibu_fahrzeug/'"
                            [displayField]="'anzeige'"
                            [focus]="false"
                            [kieneObject]="gesamtFahrzeug"
                            [params]="fahrzeugParams"
                            [placeholder]="'Fahrzeug'"
                            [required]="false"
                        >
                        </kiene-autocomplete>
                    </div>
                    <mat-form-field class="field-select">
                        <mat-label>Kostenart</mat-label>
                        <mat-select [(ngModel)]="gesamtSachkonto" (selectionChange)="onGesamtKostenartChanged()">
                            <mat-option [value]="null">–</mat-option>
                            <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{ k.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="one-row pos-fibu" *ngIf="nurHonorar">
                    <div class="field-auto">
                        <kiene-autocomplete
                            (elementSelected)="setGesamtHonorarTa($event)"
                            [apiUrl]="'fibu_honorar_ta/'"
                            [displayField]="'anzeige'"
                            [focus]="false"
                            [kieneObject]="gesamtHonorarTa"
                            [params]="honorarTaParams"
                            [placeholder]="'Honorar-TA'"
                            [required]="false"
                        >
                        </kiene-autocomplete>
                    </div>
                    <mat-form-field class="field-select">
                        <mat-label>Kostenart</mat-label>
                        <mat-select [(ngModel)]="gesamtSachkonto" (selectionChange)="onGesamtKostenartChanged()">
                            <mat-option [value]="null">–</mat-option>
                            <mat-option *ngFor="let k of kostenarten" [value]="k.value">{{ k.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="one-row" *ngIf="fahrzeugManuell || gemeinkostenTypCtrl.value === 2">
                    <div class="field-auto">
                        <kiene-autocomplete
                            (elementSelected)="setGesamtTierarzt($event)"
                            [apiUrl]="'tierarzt/'"
                            [displayFields]="['titel', 'vorname', 'nachname']"
                            [focus]="false"
                            [kieneObject]="gesamtTierarzt"
                            [placeholder]="'Tierarzt (Zeile)'"
                            [required]="false"
                        >
                        </kiene-autocomplete>
                    </div>
                </div>
            </ng-container>

            <div class="rabatt-row" *ngIf="!nurGesamtbetrag">
                <mat-form-field class="field-num-wide">
                    <mat-label>Rabatt (Netto)</mat-label>
                    <input [(ngModel)]="rabattNetto" matInput kieneDeNumber inputmode="decimal" />
                    <span matSuffix>&euro;</span>
                </mat-form-field>
                <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    (click)="applyRabatt()"
                    [disabled]="!canApplyRabatt"
                    matTooltip="Rabatt anteilig auf Positionen (ohne Versand)"
                >
                    Verteilen
                </button>
                <button
                    mat-button
                    type="button"
                    (click)="undoRabatt()"
                    [disabled]="!nettoVorRabatt"
                    matTooltip="Letzte Rabatt-Verteilung rückgängig"
                >
                    Rückgängig
                </button>
            </div>
            <p class="hint rabatt-hint" *ngIf="!nurGesamtbetrag">
                Ziel-Netto = Summe − Rabatt. Versand bleibt unverändert; keine eigene Rabattzeile.
            </p>

            <div class="totals">
                <div class="totals-row" *ngIf="!nurGesamtbetrag">
                    <span>Netto gesamt</span>
                    <strong>{{ sumNetto | number: '1.2-2' }} €</strong>
                </div>
                <div class="totals-row" *ngIf="!nurGesamtbetrag">
                    <span>MwSt gesamt</span>
                    <strong>{{ sumMwst | number: '1.2-2' }} €</strong>
                </div>
                <div class="totals-row totals-brutto" *ngIf="!nurGesamtbetrag">
                    <span>Brutto gesamt</span>
                    <strong>{{ sumBrutto | number: '1.2-2' }} €</strong>
                </div>

                <ng-container *ngIf="nurGesamtbetrag">
                    <div class="one-row totals-edit">
                        <mat-form-field class="field-num-wide">
                            <mat-label>Netto gesamt</mat-label>
                            <input
                                [(ngModel)]="gesamtNetto"
                                (ngModelChange)="onGesamtNettoChanged()"
                                matInput
                                kieneDeNumber
                                inputmode="decimal"
                            />
                            <span matSuffix>&euro;</span>
                        </mat-form-field>
                        <mat-form-field class="field-mwst">
                            <mat-label>MwSt</mat-label>
                            <mat-select [(ngModel)]="gesamtMwstsatz" (ngModelChange)="onGesamtMwstsatzChanged()">
                                <mat-option *ngFor="let s of mwstSaetze" [value]="s.value">{{ s.label }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button
                            mat-icon-button
                            type="button"
                            class="mwst-calc-btn"
                            (click)="mwstVomGesamtbetragAbziehen()"
                            [disabled]="!canMwstVomGesamtbetragAbziehen()"
                            matTooltip="MwSt abziehen (Brutto → Netto)"
                        >
                            <mat-icon>calculate</mat-icon>
                        </button>
                        <mat-form-field class="field-num-wide">
                            <mat-label>MwSt gesamt</mat-label>
                            <input
                                [(ngModel)]="gesamtMwstEuro"
                                (ngModelChange)="onGesamtMwstEuroChanged()"
                                matInput
                                kieneDeNumber
                                inputmode="decimal"
                            />
                            <span matSuffix>&euro;</span>
                        </mat-form-field>
                    </div>
                    <div class="totals-row totals-brutto brutto-edit-row">
                        <span>Brutto gesamt</span>
                        <div class="brutto-edit">
                            <button
                                mat-icon-button
                                type="button"
                                (click)="adjustBruttoCent(-1)"
                                matTooltip="Brutto −1 Cent (MwSt anpassen)"
                            >
                                <mat-icon>remove</mat-icon>
                            </button>
                            <mat-form-field class="field-brutto">
                                <input
                                    [ngModel]="gesamtBrutto"
                                    (ngModelChange)="onGesamtBruttoChanged($event)"
                                    matInput
                                    kieneDeNumber
                                    inputmode="decimal"
                                />
                                <span matSuffix>&euro;</span>
                            </mat-form-field>
                            <button
                                mat-icon-button
                                type="button"
                                (click)="adjustBruttoCent(1)"
                                matTooltip="Brutto +1 Cent (MwSt anpassen)"
                            >
                                <mat-icon>add</mat-icon>
                            </button>
                            <button
                                *ngIf="extractBrutto != null && bruttoRundungsDiff !== 0"
                                mat-stroked-button
                                type="button"
                                class="brutto-beleg-btn"
                                (click)="applyExtractBrutto()"
                                matTooltip="Brutto vom Beleg übernehmen ({{ extractBrutto | number: '1.2-2' }} €)"
                            >
                                Beleg {{ extractBrutto | number: '1.2-2' }} €
                            </button>
                        </div>
                    </div>
                    <div
                        *ngIf="bruttoRundungsDiff != null && bruttoRundungsDiff !== 0"
                        class="brutto-hint"
                    >
                        Beleg-Brutto weicht um {{ bruttoRundungsDiff | number: '1.2-2' }} € ab – mit ± Cent oder „Beleg“ anpassen.
                    </div>
                </ng-container>
            </div>

            <div class="actions">
                <button
                    (click)="openPrimanotaExportVorschau()"
                    mat-stroked-button
                    type="button"
                    class="vorschau-btn"
                    matTooltip="DATEV kompakt_bu – so würde es in der Primanota stehen"
                >
                    <mat-icon>account_balance</mat-icon>
                    Primanota-Vorschau
                </button>
                <span class="actions-spacer"></span>
                <button (click)="close()" mat-button type="button">Abbrechen</button>
                <button
                    (click)="save()"
                    [disabled]="!isValid() || saving"
                    color="accent"
                    mat-flat-button
                    type="button"
                >
                    {{
                        data.mode === 'edit'
                            ? 'Speichern'
                            : data.gemeinkosten?.kosten_id
                              ? 'Prüfung speichern'
                              : 'Korrigieren & übernehmen'
                    }}
                </button>
            </div>
        </div>
    </div>
</div>
